// test2194
(2194 && 0);
